import React from "react";

import "./style.scss";

type AILoaderProps = {
  className?: string;
  message?: string;
  chipText?: string;
};

export default function AILoader({
  className,
  message = "Our AI is generating your next big idea",
  chipText = "Analysing with AI",
}: AILoaderProps) {
  return (
    <div className={["ai-loader", className].filter(Boolean).join(" ")}>
      <div className="ai-loader__bg" aria-hidden="true" />

      <div className="ai-loader__center" aria-hidden="true">
        <div className="ai-loader__card" />

        <div className="ai-loader__chip" aria-hidden="true">
          {chipText}
        </div>

        <div className="ai-loader__sparkles" aria-hidden="true">
          <span className="ai-loader__sparkle ai-loader__sparkle--lg ai-loader__sparkle--s1" />
          <span className="ai-loader__sparkle ai-loader__sparkle--sm ai-loader__sparkle--s2" />
          <span className="ai-loader__sparkle ai-loader__sparkle--lg ai-loader__sparkle--s3" />
          <span className="ai-loader__sparkle ai-loader__sparkle--lg ai-loader__sparkle--s4" />
          <span className="ai-loader__sparkle ai-loader__sparkle--lg ai-loader__sparkle--s5" />
          <span className="ai-loader__sparkle ai-loader__sparkle--sm ai-loader__sparkle--s6" />
        </div>
      </div>

      <p className="ai-loader__text">
        <span className="ai-loader__textBase">{message}</span>
      </p>
    </div>
  );
}

